// Selectors
import { ApplicationState } from '../../store';


export const issuesSelector = (state: ApplicationState) => state.issueState
export const issueSelector = (state: ApplicationState) => state.issueState

